/** @jsxRuntime classic */
/** @jsx jsx */
import { gql } from '@apollo/client';
import { Button, DownloadIcon } from '@bottlebooks/gatsby-theme-base';
// import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';

export default function ProductInfoSheetButton({ product, ...rest }) {
  if (!product?.infoSheet?.url) return null;
  return (
    <Button
      href={product.wfsInfoSheet.url}
      target="_blank"
      rel="noopener noreferrer"
      variant="outline"
      sx={{ textAlign: 'center' }}
      {...rest}
    >
      <DownloadIcon
        size="small"
        sx={{ marginRight: 2, color: 'currentColor' }}
      />
      Download info sheet
    </Button>
  );
}
// WFS doesn't like the newer design, which is now the default.
export const fragment = graphql`
  fragment wfs_bb_ProductInfoSheetButton on Bottlebooks_RegisteredProduct {
    wfsInfoSheet: infoSheet(templateId: "bottlebooks/collectionInfoSheet2020") {
      url
    }
  }
`;

ProductInfoSheetButton.fragment = gql`
  fragment wfs_ProductInfoSheetButton on RegisteredProduct {
    wfsInfoSheet: infoSheet(templateId: "bottlebooks/collectionInfoSheet2020") {
      url
    }
  }
`;
